"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import { motion } from "framer-motion";
import Image from "next/image";
import GradientButton from "@/components/ui/GradientButton";
import { FaChevronRight } from "react-icons/fa";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
export default function ComparativeSection() {
  const $ = _c(32);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== desktopAnimations) {
    t2 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.6,
      ease
    };
    t4 = {
      once: true
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t2) {
    t5 = <motion.h2 initial={t0} whileInView={t1} animate={t2} transition={t3} viewport={t4} className="font-poppins text-[1.9rem] sm:text-[2.25rem] lg:text-[2.5rem] font-bold text-[#141047] mb-5 leading-tight dark:text-white">Build a Doctor Appointment Booking CRM Like Zocdoc, DrChrono, and Practice Fusion</motion.h2>;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="text-gray-500 text-base lg:text-lg mb-8 leading-relaxed max-w-lg dark:text-gray-400">Easily migrate patient data from other EMRs, connect your pharmacy, and integrate lab support with our doctor appointment CRM</p>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div><GradientButton href="/contact" variant="peach-pink">Book A Demo <FaChevronRight className="ml-1 text-[12px]" /></GradientButton></div>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5) {
    t8 = <div className="order-2 lg:order-1 flex flex-col justify-center p-10 lg:p-16 z-10">{t5}{t6}{t7}</div>;
    $[14] = t5;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== desktopAnimations) {
    t9 = desktopAnimations ? {
      opacity: 0,
      scale: 0.8
    } : false;
    $[16] = desktopAnimations;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== desktopAnimations) {
    t10 = desktopAnimations ? {
      opacity: 1,
      scale: 1
    } : undefined;
    $[18] = desktopAnimations;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== desktopAnimations) {
    t11 = desktopAnimations ? undefined : {
      opacity: 1,
      scale: 1
    };
    $[20] = desktopAnimations;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      duration: 0.8,
      ease
    };
    t13 = {
      once: true
    };
    $[22] = t12;
    $[23] = t13;
  } else {
    t12 = $[22];
    t13 = $[23];
  }
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Image src="/images/appointment/practice-fusion-crm.png" alt="DR CRM Integration" width={600} height={600} className="h-auto w-full object-contain" />;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t9) {
    t15 = <div className="order-1 lg:order-2 relative w-full flex items-center justify-center"><motion.div initial={t9} whileInView={t10} animate={t11} transition={t12} viewport={t13} className="w-full max-w-[550px]">{t14}</motion.div></div>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t9;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t15 || $[30] !== t8) {
    t16 = <section className="bg-white py-16 md:py-24 px-6 font-sans dark:bg-gray-900"><div className="max-w-7xl mx-auto"><div className="bg-[#fdf3f0] rounded-[2rem] overflow-hidden grid grid-cols-1 lg:grid-cols-2 items-center dark:bg-gray-800">{t8}{t15}</div></div></section>;
    $[29] = t15;
    $[30] = t8;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  return t16;
}